import { Component, OnInit } from '@angular/core';
import { Dealer } from '../../shared/models/dealer.interface';
import { AccountService } from '../services/account.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DealerAccountData } from '../../shared/models/dealer-account.interface';
import { DealerAccountComponent } from '../../shared/controls/dealer-account/dealer-account.component';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-account-main',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent extends AbstractBiditComponent implements OnInit {
  pageTitle: string = "Account";
  termLocale: string = "en";
  dealer: Dealer;
  quoteOnly: boolean;
  constructor(deviceDetectorService: DeviceDetectorService,
    private accountService: AccountService, public dialog: MatDialog) {
    super(deviceDetectorService);
  }

  ngOnInit(): void {
    this.accountService.getDealer()
      .subscribe({
        next: (data: Dealer) => {
          this.dealer = data;
          this.quoteOnly = data.dealer_QuoteOnly;
        },
        error: (error: string) => this.onError(error)
      });
  }

  showEdit() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: this.dealer.dealer_ID, isDealerAdmin: true } as DealerAccountData;
    dialogConfig.width = '1075px';
    dialogConfig.maxHeight = '850px';

    const accountDialogRef = this.dialog.open(DealerAccountComponent, dialogConfig);

    accountDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        this.dealer = result;
      }
    });
  }

}
